import { useLocation } from 'react-router-dom';
import { useConfig } from '@/api/queries';
import type { AdsConfig } from '@/api/types';
import { useAuth } from '@/stores/auth';
import { useModeration } from '@/stores/moderation';
import { adsOnFor, isAdExcludedPath } from './runtime';

/** `GET /v1/config.ads` — null in most environments (ads off). */
export function useAdsConfig(): AdsConfig | null {
  const config = useConfig();
  return config.data?.ads ?? null;
}

export interface AdsGate {
  ads: AdsConfig | null;
  /** Ads exist for this person (config on, ads_eligible, not Plus). */
  on: boolean;
  /** …and this screen may show them (not excluded, not suspended/banned). */
  here: boolean;
}

export function useAdsGate(): AdsGate {
  const ads = useAdsConfig();
  const me = useAuth((s) => s.me);
  const { pathname } = useLocation();
  const blocked = useModeration((s) => !!s.blocked || !!s.closed);
  const on = adsOnFor(ads, me);
  return { ads: on ? ads : null, on, here: on && !blocked && !isAdExcludedPath(pathname) };
}

/** Rewarded placements are off when the rewarded unit is "" (or ads are off for this person). */
export function useRewardedAvailable(): AdsConfig | null {
  const g = useAdsGate();
  return g.here && g.ads && g.ads.units.rewarded ? g.ads : null;
}
